module.exports = __webpack_public_path__ + "img/error.84622e4c.svg";